import {FC} from 'react'

import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {Text, TextFontWeight} from '@/components/common/content/Text'
import {FormSelectedItem} from '@/components/common/form/selection/FormSelectedItem'
import {FormSelection} from '@/components/common/form/selection/FormSelection'
import {JurisdictionFlag} from '@/components/common/jurisdiction/JurisdictionFlag'
import {getCountryCards} from '@/content/countryCards'
import {theme} from '@/theme/theme'
import {Jurisdiction} from '@/utils/countries/constants'
import {useLanguage} from '@/utils/i18n/language'

type SelectedMarketsListProps = {
  selectedJurisdictions?: Jurisdiction[]
  title: string
  description: string
  adjustButtonText: string
  selectButtonText: string
  openModal: () => void
  onRemove?: (jurisdiction: Jurisdiction) => void
}

export const SelectedMarketsList: FC<SelectedMarketsListProps> = ({
  selectedJurisdictions,
  title,
  description,
  adjustButtonText,
  selectButtonText,
  openModal,
  onRemove,
}) => {
  const language = useLanguage()
  const numOfSelectedJurisdictions = selectedJurisdictions?.length ?? 0
  const allCountryCards = getCountryCards(language, null, null)

  return (
    <>
      <FormSelection
        title={title}
        description={description}
        buttonText={numOfSelectedJurisdictions > 0 ? adjustButtonText : selectButtonText}
        buttonVariant={
          numOfSelectedJurisdictions > 0 ? ButtonVariant.tertiary : ButtonVariant.primary
        }
        openModal={openModal}
      >
        {numOfSelectedJurisdictions > 0 &&
          selectedJurisdictions?.map((code) => {
            const country = allCountryCards.find(({key}) => key === code)

            return country ? (
              <FormSelectedItem key={code} onClick={onRemove ? () => onRemove(code) : undefined}>
                <div className="country">
                  <div className="flag">
                    <JurisdictionFlag jurisdiction={code} isOutlined />
                  </div>
                  <Text fontWeight={TextFontWeight.semibold}>{country.title}</Text>
                </div>
              </FormSelectedItem>
            ) : null
          })}
      </FormSelection>

      <style jsx>{`
        .country {
          display: flex;
          align-items: center;
        }
        .flag {
          margin-right: ${theme.spacing[2]};
        }
      `}</style>
    </>
  )
}
